import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';
// @ts-ignore
import HarvestEventTypeSchemaEntityTypeName from 'components/HarvestEventTypeSchemaEntityTypeName';

const ForecastsTableHead = (): React.ReactElement => (
    <Table.Header
        // HACK inline styles
        style={{
            fontSize: 14
        }}
    >
        <Table.Row>
            <TableHeadTableCell
                label={<HarvestEventTypeSchemaEntityTypeName />}
                value="name"
                defaultSort="name"
            />
            <TableHeadTableCell label="RPIN" value="orchardRpin" />
            <TableHeadTableCell label="Variety" value="variety.name" />
            <TableHeadTableCell
                label="Forecasted Bins"
                value="quantityForecast.value"
            />
            <TableHeadTableCell
                label="Est. Count Size"
                value="quantityForecast.size"
            />
            <TableHeadTableCell label="Status" value="quantityForecast.value" />
            <Table.HeaderCell />
        </Table.Row>
    </Table.Header>
);

export default ForecastsTableHead;
